import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex row" }
const _hoisted_2 = {
  key: 0,
  class: "flex-column flex-md-row-auto w-100 w-md-250px w-xxl-350px"
}
const _hoisted_3 = { class: "card mb-10 mb-md-0" }
const _hoisted_4 = { class: "card-body py-10 px-6" }
const _hoisted_5 = { class: "d-flex flex-column mb-10 px-3" }
const _hoisted_6 = {
  class: "input-group input-group-solid",
  id: "kt_chat_aside_search"
}
const _hoisted_7 = {
  class: "input-group-text",
  id: "basic-addon1"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1 svg-icon-dark" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control ps-0 py-4 h-auto",
  placeholder: "Search"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<ul class=\"menu menu-column menu-rounded menu-gray-600 menu-hover-bg-light-primary menu-active-bg-light-primary fw-bold mb-10\"><li class=\"menu-content fw-bold pb-2 px-3\"><span class=\"fs-3 fw-bolder\">Premium Authors</span></li><li class=\"menu-item px-3 pb-1\"><a href=\"#\" class=\"menu-link fs-6 px-3\"> Getting Started </a></li><li class=\"menu-item px-3 pb-1\"><a href=\"#\" class=\"menu-link fs-6 px-3 active\"> Popular Articles </a></li><li class=\"menu-item px-3 pb-1\"><a href=\"#\" class=\"menu-link fs-6 px-3\"> Uploading Theme </a></li><li class=\"menu-item px-3\"><a href=\"#\" class=\"menu-link fs-6 px-3\"> Licensing </a></li></ul><ul class=\"menu menu-column menu-rounded menu-gray-600 menu-hover-bg-light-primary menu-active-bg-light-primary fw-bold\"><li class=\"menu-content fw-bold pb-2 px-3\"><span class=\"fs-3 fw-bolder\">Theme Customers</span></li><li class=\"menu-item px-3 pb-1\"><a href=\"#\" class=\"menu-link fs-6 px-3\"> User Profile </a></li><li class=\"menu-item px-3 pb-1\"><a href=\"#\" class=\"menu-link fs-6 px-3\"> Timeline </a></li><li class=\"menu-item px-3 pb-1\"><a href=\"#\" class=\"menu-link fs-6 px-3\"> Pricing Tables </a></li><li class=\"menu-item px-3\"><a href=\"#\" class=\"menu-link fs-6 px-3\"> Wizard Options </a></li></ul>", 2)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "card-body py-10" }
const _hoisted_14 = { class: "fs-4 text-white fw-bold mb-0" }
const _hoisted_15 = {
  class: "text-white fw-bolder fs-1 mb-5",
  style: {"font-size":"calc(2.3rem + 0.5vw) !important","font-weight":"400"}
}
const _hoisted_16 = {
  class: "lead",
  style: {"font-size":"calc(0.7rem + 0.4vw) !important","font-weight":"400"}
}
const _hoisted_17 = { style: {"font-size":"calc(0.8rem + 0.4vw) !important","font-weight":"400"} }
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { class: "fs-4 text-gray-800 fw-bold mb-0" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("iframe", {
  class: "col-lg-6",
  src: "https://www.youtube.com/embed/cW2tfICi7yc",
  type: "application/x-shockwave-flash",
  height: "500"
}, null, -1)
const _hoisted_22 = { class: "px-10 py-15 col-lg-6 bg-light" }
const _hoisted_23 = { class: "fs-2 text-gray-800 fw-bold mb-0" }
const _hoisted_24 = {
  class: "text-dark fw-bolder fs-1 mb-5",
  style: {"font-size":"calc(2rem + 0.5vw) !important","font-weight":"400"}
}
const _hoisted_25 = {
  class: "lead",
  style: {"font-size":"calc(0.9rem + 0.4vw) !important","font-weight":"400"}
}
const _hoisted_26 = { style: {"font-size":"calc(0.9rem + 0.4vw) !important","font-weight":"400"} }
const _hoisted_27 = { class: "card" }
const _hoisted_28 = { class: "card-body py-10" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h2", { class: "text-dark fw-bolder fs-1 mb-5" }, "Popular Articles", -1)
const _hoisted_30 = {
  class: "accordion accordion-icon-toggle",
  id: "kt_accordion_1"
}
const _hoisted_31 = { class: "mb-5" }
const _hoisted_32 = {
  class: "accordion-header py-3 d-flex",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_item_1"
}
const _hoisted_33 = { class: "accordion-icon" }
const _hoisted_34 = { class: "svg-icon svg-icon-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }, " Planejar um negócio pode ser avassalador. ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_accordion_1_item_1",
  class: "fs-6 collapse show ps-10",
  "data-bs-parent": "#kt_accordion_1"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. "),
  /*#__PURE__*/_createElementVNode("div", null, " It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ")
], -1)
const _hoisted_37 = { class: "mb-5" }
const _hoisted_38 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_item_2"
}
const _hoisted_39 = { class: "accordion-icon" }
const _hoisted_40 = { class: "svg-icon svg-icon-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }, " How To Create Channel ? ", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_accordion_1_item_2",
  class: "collapse fs-6 ps-10",
  "data-bs-parent": "#kt_accordion_1"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, " There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. "),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. "),
  /*#__PURE__*/_createElementVNode("div", null, " It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. ")
], -1)
const _hoisted_43 = { class: "mb-5" }
const _hoisted_44 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_item_3"
}
const _hoisted_45 = { class: "accordion-icon" }
const _hoisted_46 = { class: "svg-icon svg-icon-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }, " What are the support terms & conditions ? ", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_accordion_1_item_3",
  class: "collapse fs-6 ps-10",
  "data-bs-parent": "#kt_accordion_1"
}, " Some plugins may ask for a purchase code for registration/activation once installed, however, you can simply ignore these messages as bundled plugins do not require activation or registration. ", -1)
const _hoisted_49 = { class: "mb-5" }
const _hoisted_50 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_item_4"
}
const _hoisted_51 = { class: "accordion-icon" }
const _hoisted_52 = { class: "svg-icon svg-icon-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }, " What is the 6 Months support extention ? ", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_accordion_1_item_4",
  class: "collapse fs-6 ps-10",
  "data-bs-parent": "#kt_accordion_1"
}, " Some plugins may ask for a purchase code for registration/activation once installed, however, you can simply ignore these messages as bundled plugins do not require activation or registration. The plugin will still work as intended with the theme once the theme has been activated/registered. When a plugin is updated, the theme author will include the latest version of the bundled plugin with their next theme update. ", -1)
const _hoisted_55 = { class: "mb-5" }
const _hoisted_56 = {
  class: "accordion-header py-3 d-flex collapsed",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_accordion_1_item_5"
}
const _hoisted_57 = { class: "accordion-icon" }
const _hoisted_58 = { class: "svg-icon svg-icon-4" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("h3", { class: "fs-4 text-gray-800 fw-bold mb-0 ms-4" }, " How can I keep up to date my item ? ", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_accordion_1_item_5",
  class: "collapse fs-6 ps-10",
  "data-bs-parent": "#kt_accordion_1"
}, " Some plugins may ask for a purchase code for registration/activation once installed, however, you can simply ignore these messages as bundled plugins do not require activation or registration. The plugin will still work as intended with the theme once the theme has been activated/registered. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_header_page = _resolveComponent("header-page")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
                      ])
                    ]),
                    _hoisted_9
                  ])
                ])
              ]),
              _hoisted_10
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.faq)
      ? (_openBlock(), _createBlock(_component_header_page, {
          key: 1,
          id: "header-page-faq",
          title: _ctx.faq.title,
          subtitle: _ctx.faq.shortDescription,
          search: _ctx.faq.search,
          "bg-image": "https://images.unsplash.com/photo-1522932753915-9ee97e43e3d9?auto=format&fit=crop&q=80&w=1854&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
          "bg-image-small": _ctx.faq.bannerSmall,
          lg: false,
          bgHex: "#fff",
          breadcrumbs: _ctx.faq.breadcrumbs,
          margin: "mb-xxl-6"
        }, null, 8, ["title", "subtitle", "search", "bg-image-small", "breadcrumbs"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faq.metadata.context, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "card bg-dark text-white my-5"
        }, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h4", _hoisted_14, _toDisplayString(item.title), 1),
            _createElementVNode("h2", _hoisted_15, _toDisplayString(item.cta), 1),
            _createElementVNode("p", _hoisted_16, _toDisplayString(item.subtitle), 1),
            _createElementVNode("ul", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.values, (i, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  textContent: _toDisplayString(i)
                }, null, 8, _hoisted_18))
              }), 128))
            ])
          ])
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.faq.metadata.how_works, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "col pt-1 mt-lg-5"
        }, [
          _createElementVNode("h4", _hoisted_19, _toDisplayString(item.description), 1),
          _createElementVNode("h1", {
            class: "fw-bolder fs-1 text-dark mb-10",
            style: {"font-size":"calc(2.7rem + 0.7vw) !important","font-weight":"400"},
            innerHTML: item.title
          }, null, 8, _hoisted_20),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.values, (i, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "row my-10"
            }, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h2", _hoisted_23, _toDisplayString(i.title), 1),
                _createElementVNode("h1", _hoisted_24, _toDisplayString(i.cta), 1),
                _createElementVNode("p", _hoisted_25, _toDisplayString(i.description), 1),
                _createElementVNode("ul", _hoisted_26, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(i.itens, (x, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(x.label), 1))
                  }), 128))
                ])
              ])
            ]))
          }), 128))
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_35
              ]),
              _hoisted_36
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("span", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_41
              ]),
              _hoisted_42
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("span", _hoisted_45, [
                  _createElementVNode("span", _hoisted_46, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_47
              ]),
              _hoisted_48
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("span", _hoisted_51, [
                  _createElementVNode("span", _hoisted_52, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_53
              ]),
              _hoisted_54
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("span", _hoisted_57, [
                  _createElementVNode("span", _hoisted_58, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                  ])
                ]),
                _hoisted_59
              ]),
              _hoisted_60
            ])
          ])
        ])
      ])
    ])
  ]))
}